import ClientProvider from '../providers/ClientProvider';
import '../styles/globals.css';

function MyApp(props) {
  const { Component, pageProps } = props;

  return (
    <ClientProvider>
      <main>
        <Component {...props} />
      </main>
      <div id="portal" />
    </ClientProvider>
  );
}

export default MyApp;
